import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";
import {DatetoHtml2, Prices} from '../../components/functions'

const getHour = (date) => {
  const mDate = new Date(date)

  return (mDate.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'}))
}

const Item = ({item, langPlace}) => {
  const {id, type, price} = item
  return (
    <div className='panel-item'>
      <div className='col-md-9 no-padding'>{`${langPlace[type]} #${id}`}</div>
      <div className='col-md-3 no-padding total-partial'>{Prices(price)}</div>
    </div>
  )
}

class panelBreakdown extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langCalendar = languages[langUrl].fastbooking.calendar
    const langPlace = languages[langUrl].resume.breakdown

    const {calcDeparture, calcReturn, available: {departures, returns}} = this.props.settings
    const {travel, departuretravel, returntravel} = this.props.values
    const {nCars, nMotorcycles, nVans, nBikes} = this.props.values

    const dep = departures[departuretravel]
    const ret = (travel===0) ? returns[returntravel]: undefined

    const total = calcDeparture.price + ((travel === 0) ? calcReturn.price: 0)
    const classname = (travel === 0) ? 'col-lg-6 col-md-6 col-sm-12 col-xs-12': 'col-lg-12 col-md-12 col-sm-12 col-xs-12'

    return (
      <div className='resume-breakdown'>
        <div className='row'>
          <div className='col-md-12 no-padding'>
            <div className='section-title'>{langPlace.title}</div>
            <div className='row'>
              <div className={classname}>
                <div className="trip-going">
                  <div className='cuadre-height cuadre-principal'>
                    <div>
                      <div className='cuadre-title'>{langPlace.tripgoing}</div>
                      <div className='cuadre-subtitle'>{`${dep.origin.name}`}</div>
                    </div>
                  </div>
                  <div className='cuadre-height cuadre-secondary'>
                    <div>
                      <div className='cuadre-title'>{langPlace.departuredate}</div>
                      <div className='cuadre-subtitle'>{DatetoHtml2(dep.departure, langCalendar)}</div>
                    </div>
                  </div>
                  <div className='cuadre-height cuadre-secondary'>
                    <div>
                      <div className='cuadre-title'>{langPlace.departuretime}</div>
                      <div className='cuadre-subtitle'>{getHour(dep.departure)}</div>
                    </div>
                  </div>

                  <div className='panel-title'>{langPlace.reservation}</div>
                  <div>
                    <div className='list-items'>
                      {calcDeparture.passengers.map((item, index) =>
                        <Item key={index} item={item} langPlace={langPlace}/>
                      )}
                    </div>
                    <div className='separating-subline'><hr/></div>
                  </div>
                  {((nCars + nMotorcycles + nVans + nBikes) > 0)?
                    <div>
                      <div className='panel-title'>{langPlace.vehicles}</div>
                      <div className='list-items'>
                        {calcDeparture.vehicles.map((item, index) =>
                          <Item key={index} item={item} langPlace={langPlace}/>
                        )}
                      </div>
                      <div className='separating-subline'><hr/></div>
                    </div>
                  :''}
                  <div className='row'>
                    <div className='col-md-12'>
                      <div className='panel-partial'>{`${langPlace.totalgoing} ${Prices(calcDeparture.price)}`}</div>
                    </div>
                  </div>
                </div>
                </div>
                {(travel === 0)?
                <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                  <div className="trip-return">
                    <div className='cuadre-height cuadre-principal'>
                      <div>
                        <div className='cuadre-title'>{langPlace.tripreturn}</div>
                        <div className='cuadre-subtitle'>{`${ret.origin.name}`}</div>
                      </div>
                    </div>
                    <div className='cuadre-height cuadre-secondary'>
                      <div>
                        <div className='cuadre-title'>{langPlace.departuredate}</div>
                        <div className='cuadre-subtitle'>{DatetoHtml2(ret.departure, langCalendar)}</div>
                      </div>
                    </div>
                    <div className='cuadre-height cuadre-secondary'>
                      <div>
                        <div className='cuadre-title'>{langPlace.departuretime}</div>
                        <div className='cuadre-subtitle'>{getHour(ret.departure)}</div>
                      </div>
                    </div>
                    <div className='panel-title'>{langPlace.reservation}</div>
                    <div>
                      <div className='list-items'>
                        {calcReturn.passengers.map((item, index) =>
                          <Item key={index} item={item} langPlace={langPlace}/>
                        )}                    </div>
                      <div className='separating-subline'><hr/></div>
                    </div>

                      {((nCars + nMotorcycles + nVans +  nBikes) > 0)?
                        <div>
                          <div className='panel-title'>{langPlace.vehicles}</div>
                          <div className='list-items'>
                            {calcReturn.vehicles.map((item, index) =>
                              <Item key={index} item={item} langPlace={langPlace}/>
                            )}
                          </div>
                          <div className='separating-subline'><hr/></div>
                        </div>
                      :''}
                      <div className='row'>
                        <div className='col-md-12'>
                          <div className='panel-partial'>{`${langPlace.totalreturn} ${Prices(calcReturn.price)}`}</div>
                        </div>
                      </div>
                    </div>
                  </div>
              :''}
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div className='separating-subline'><hr/></div>
                <div className='resume-total'><i className="fa fa-tag" aria-hidden="true"></i>{`${langPlace.totalreservation} ${Prices(total)}`}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
(state) => ({settings: state.settings, values: state.data.values})
)(panelBreakdown)



// WEBPACK FOOTER //
// ./src/shared/routes/routeResume/components/panelBreakdown.js